import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { Router } from '@angular/router';
import { AppConstants } from '../../../utils/AppConstants';
import { BaseSearchCriteria } from '../../../models/searchCriteria/BaseSearchCriteria';
import { TooltipDirective } from '../../../utils/tooltip.directive';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { ConfirmAlertComponent } from '../../shared/confirm-alert/confirm-alert.component';
import { ThOrderingComponent } from '../../shared/th-ordering/th-ordering.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppEnums } from '../../../models/AppEnums';
import { FilterPanelComponent } from '../../shared/filter-panel/filter-panel.component';
import { CAMERA_SEARCH_CRITERIA_KEY, CameraSearchCriteria } from '../../../models/searchCriteria/CameraSearchCriteria';
import { Camera } from '../../../models/Camera';
import { CameraService } from '../../../services/camera.service';
import { AlertService } from '../../shared/alert/alert.service';
import { StorageService } from '../../../services/storage.service';

@Component({
  selector: 'app-camera-list',
  standalone: true,
  imports: [
    CommonModule,
    NgxPaginationModule,
    ThOrderingComponent,
    ConfirmAlertComponent,
    HasPermissionDirective,
    FilterPanelComponent,
    FormsModule,
    ReactiveFormsModule,
    TooltipDirective],
  templateUrl: './camera-list.component.html',
  styleUrl: './camera-list.component.scss'
})
export class CameraListComponent implements OnInit {

  searchForm!: FormGroup;
  emptySearchCriteria: CameraSearchCriteria = { name: undefined, pageSize: AppConstants.pageSize, pageNumber: 1 };
  searchCriteria: CameraSearchCriteria = { ...this.emptySearchCriteria };

  cameras: Camera[] = [];

  selectedCamera?: Camera;
  totalItems: number = 0;

  showConfirmationModal: boolean = false;
  confirmationMessage: string = '';
  confirmOperationType: 'DEL' | undefined = undefined;

  constructor(
    private cameraService: CameraService,
    private alertService: AlertService,
    private storageService: StorageService,
    private fullSpinnerService: FullSpinnerService,
    private fb: FormBuilder,
    private router: Router) {
    this.searchForm = this.fb.group({
      name: [undefined],
    });
    this.clearFilter();
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.fullSpinnerService.spinner(undefined);
    if (AppConstants.storeNavigationInfo) {
      let scObj = this.storageService.retrieveNavigationInfo(CAMERA_SEARCH_CRITERIA_KEY);
      if (scObj !== null) {
        this.searchCriteria = scObj;
      }
      else
        this.storageService.saveNavigationInfo(this.searchCriteria, CAMERA_SEARCH_CRITERIA_KEY);
    }
    this.searchForm.patchValue(this.searchCriteria);
    this.find();
  }


  edit(id?: number) {
    this.router.navigate(['cameras/' + id]);
  }


  find() {
    this.fullSpinnerService.spinner('');
    this.storageService.saveNavigationInfo(this.searchCriteria, CAMERA_SEARCH_CRITERIA_KEY);
    this.cameraService.find(this.searchCriteria).subscribe({
      next: (res) => {
        this.cameras = res.items;
        this.totalItems = res.totalItems;
      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }

  search(): void {
    this.searchCriteria = {
      ...this.searchCriteria,
      ...this.searchForm.value
    }
    this.find();
  }

  clearFilter(withSearch: boolean = false) {
    this.searchCriteria = { ...this.emptySearchCriteria };
    this.searchForm.patchValue(this.searchCriteria);
    if (withSearch)
      this.find();
  }
  pageChanged(event: number) {
    this.searchCriteria.pageNumber = event;
    this.find();
  }

  ordering(baseSearchCriteria: BaseSearchCriteria | undefined) {
    this.searchCriteria = baseSearchCriteria as CameraSearchCriteria
    this.find();
  }

  computeNameType(id: string) {
    return AppEnums.cameraTypes.find(type => type.id === id)?.description
  }


  confirmOperation(camera: Camera, confirmOperationType: "DEL" | undefined) {
    this.showConfirmationModal = true;
    this.confirmOperationType = confirmOperationType;
    if (confirmOperationType === 'DEL') {
      this.confirmationMessage = "Eliminazione camera - Sicuro di voler eliminare la camera " + camera.name;
    }
    this.selectedCamera = camera;
  }


  cancelModalOperationExec() {
    this.selectedCamera = undefined;
    this.showConfirmationModal = false;
  }

  modalOperationExec() {
    this.fullSpinnerService.spinner('');
    if (this.confirmOperationType === 'DEL') {
      this.cameraService.delete(this.selectedCamera!.id!).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleDeleteSuccessMessage, [AppConstants.successMessage], true);
          this.cancelModalOperationExec();
          this.fullSpinnerService.spinner(undefined);
          this.find()
        }, complete: () => {

        }
        , error: () => {
          this.cancelModalOperationExec();
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}

